import { Modal } from "react-bootstrap";
import "react-phone-number-input/style.css";
import { useCallback, memo } from "react";
import { Users } from "../../types/Types";
import {
  BusinessMembershipFormData,
  YouthMembershipFormData,
} from "../../types/UserData";
import EditYouthData from "./EditYouthData";
import EditBusinessData from "./EditBusinessData";

interface EditModalProps {
  showEditModal: boolean;
  setShowEditModal: (show: boolean) => void;
  userData: Users | null;
  completionPercent?: number;
}

const EditModal = memo(function EditModal({
  showEditModal,
  setShowEditModal,
  userData,
  completionPercent,
}: EditModalProps) {
  const handleClose = useCallback(() => {
    setShowEditModal(false);
  }, [setShowEditModal]);

  return (
    <Modal
      centered
      size="lg"
      show={showEditModal}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {userData?.user.membershipName === "Youth Membership" ||
        userData?.user.membershipName === "Early Stage Membership" ? (
          <EditYouthData
            showEditModal={showEditModal}
            defaultData={userData.user as unknown as YouthMembershipFormData}
            defaultImages={userData?.imageUrls}
            setShowEditModal={setShowEditModal}
            completionPercent={completionPercent}  
          />
        ) : (
          <EditBusinessData
            showEditModal={showEditModal}
            defaultData={
              userData?.user as unknown as BusinessMembershipFormData
            }
            defaultImages={userData?.imageUrls}
            setShowEditModal={setShowEditModal}
            completionPercent={completionPercent}
          />
        )}
      </Modal.Body>
    </Modal>
  );
});

EditModal.displayName = "EditModal";

export default EditModal;
